import React, { useState } from "react";
import novemberCandidatePortraits from "../../data/elections/novemberCandidatePortraits";

const PARTY_STYLES = {
  Republican: { code: "R", color: "#dc3545" },
  Democratic: { code: "D", color: "#0d6efd" },
  Independent: { code: "I", color: "#198754" },
  Nonpartisan: { code: "—", color: "#198754" },
};

const CandidatePortrait = ({ name }) => {
  const [failed, setFailed] = useState(false);
  const initials = name.split(/\s+/).slice(0, 2).map((word) => word[0]).join("");
  const portrait = novemberCandidatePortraits[name];

  return (
    <div className="federal-primary-avatar november-candidate-avatar" aria-hidden="true">
      {portrait && !failed
        ? <img src={portrait.src} alt="" style={{ objectPosition: portrait.position || "50% 35%" }} onError={() => setFailed(true)} />
        : <span>{initials}</span>}
    </div>
  );
};

const PartyLane = ({ race, party }) => {
  const candidates = race.candidates.filter((person) => person.party === party);
  const { code, color } = PARTY_STYLES[party];
  const independent = party === "Independent" || party === "Nonpartisan";

  return (
    <section
      className={`federal-primary-party-lane november-party-lane${independent ? " november-independent-lane" : ""}`}
      aria-label={`${race.title} ${party} candidates`}
      style={{ "--party-color": color, "--party-surface": `${color}0a`, "--party-border": `${color}40` }}
    >
      <div className="federal-primary-lane-header">
        <span aria-hidden="true">{code}</span>
        <strong>{party === "Nonpartisan" ? "No party listed on ballot" : `${party} candidate${candidates.length === 1 ? "" : "s"}`}</strong>
        <small>{candidates.length} candidate{candidates.length === 1 ? "" : "s"}</small>
      </div>
      <ul className="federal-primary-candidate-list november-party-candidates">
        {candidates.map((person) => (
          <li key={person.name} className="federal-primary-candidate-card">
            <CandidatePortrait name={person.name} />
            <div className="federal-primary-candidate-copy">
              <strong>{person.name}</strong>
              <span>{party === "Nonpartisan" ? "Party not listed" : party}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

const NovemberCandidateMatchup = ({ race }) => {
  const parties = Object.keys(PARTY_STYLES).filter((party) => race.candidates.some((person) => person.party === party));
  const major = parties.filter((party) => party === "Republican" || party === "Democratic");
  const other = parties.filter((party) => !major.includes(party));
  if (!parties.length) return <p className="november-empty-contest">No named candidates are printed for this office. See the official ballot for write-in instructions.</p>;

  return (
    <div className="november-matchup">
      {major.length > 0 && <div className={major.length === 2 ? "november-major-matchup" : "november-single-party"}>
        {major.map((party, index) => <React.Fragment key={party}>
          {index > 0 && <div className="federal-primary-vs" aria-hidden="true">vs</div>}
          <PartyLane race={race} party={party} />
        </React.Fragment>)}
      </div>}
      {other.map((party, index) => <React.Fragment key={party}>
        {(major.length > 0 || index > 0) && <div className="federal-primary-vs" aria-hidden="true">vs</div>}
        <PartyLane race={race} party={party} />
      </React.Fragment>)}
    </div>
  );
};

export default NovemberCandidateMatchup;
